import { render, staticRenderFns } from "./PageDisable.vue?vue&type=template&id=5a1450ec&scoped=true&"
import script from "./PageDisable.vue?vue&type=script&lang=js&"
export * from "./PageDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1450ec",
  null
  
)

export default component.exports